import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-marine-insurance-terms-data',
  templateUrl: './marine-insurance-terms-data.component.html',
  styleUrls: ['./marine-insurance-terms-data.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MarineInsuranceTermsDataComponent {}
